import { render, staticRenderFns } from "./DoctorContactsSkeleton.vue?vue&type=template&id=4c075525&scoped=true&"
var script = {}
import style0 from "./DoctorContactsSkeleton.vue?vue&type=style&index=0&id=4c075525&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c075525",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c075525')) {
      api.createRecord('4c075525', component.options)
    } else {
      api.reload('4c075525', component.options)
    }
    module.hot.accept("./DoctorContactsSkeleton.vue?vue&type=template&id=4c075525&scoped=true&", function () {
      api.rerender('4c075525', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorContacts/components/DoctorContactsSkeleton.vue"
export default component.exports